import LogoutIcon from "@mui/icons-material/Logout";
const SignoutIcon = () => {
  return <LogoutIcon sx={{ fill: "white" }} />;
};

export default SignoutIcon;
